import React from "react";

import { Box, CssBaseline } from "@mui/material";

import AudiogramEditor from "../modules/AudiogramEditor";

function AudiogramEditorPage() {
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AudiogramEditor />
    </Box>
  );
}

export default AudiogramEditorPage;
